import api from './api';

const generateOTP = (payload) => {
  return api.post('customer/v1/saphybris/generate-otp', null, payload);
};

const validateOTP = (payload) => {
  return api.post(
    'customer/v1/saphybris/validate-otp',
    null,
    payload.otp && !payload.otpValue
      ? {
          ...payload,
          otp: undefined,
          otpValue: payload.otp,
        }
      : payload
  );
};

const generateWAOTP = (payload) => {
  return api.post('customer/v1/saphybris/whatsapp/generate-otp', null, payload);
};

const validateWAOTP = (payload) => {
  return api.post('customer/v1/saphybris/whatsapp/validate-otp', null, payload);
};

export default {
  generateOTP,
  validateOTP,
  generateWAOTP,
  validateWAOTP,
};
